import {
  automobile,
  banking,
  education,
  estate,
  fintech,
  healthcare,
  immigration,
  manufacturing,
  NGO,
  recruitment,
  tourism,
} from "../../helpers/constant/imageUrl";

export const DIRECT_CARDS = [
  {
    img: "/images/icard1.webp",
    alt: "Banking legacy innovation",
    title: "Reimagine Banking: Where Legacy Meets Innovation",
    path: "/industry/banking-finance/bfsi",
  },
  {
    img: "/images/icard2.webp",
    alt: "Healthcare pharma solutions",
    title: "Transforming Healthcare and Pharma with Tailored Solutions",
    path: "/industry/healthcare&pharma/healthcare-pharma",
  },
  {
    img: "/images/icard3.webp",
    alt: "EdTech digital solutions",
    title: "Transforming EdTech through Cutting-Edge Digital Solutions",
    path: "/industry/education/edtech",
  },
  {
    img: "/images/icard4.webp",
    alt: "Retail consumer goods CRM",
    title:
      "Navigating CRM Transformation: Overcoming Retail Consumer Goods Industry Challenges",
    path: "/industry/manufacturing/rcg",
  },
  {
    img: "/images/icard5.webp",
    alt: "Automotive industry solutions",
    title: "Revolutionizing the Automotive Industry with Customized Solutions",
    path: "/industry/automobile/automobile-oem",
  },
  {
    img: "/images/icard6.webp",
    alt: "Hospitality CRM solutions",
    title:
      "Revolutionizing Hospitality: Streamlined Experiences with CRM Solutions",
    path: "/industry/tourism&hospitality/hotels-tourism",
  },
  {
    img: "/images/icard7.webp",
    alt: "Staffing talent solutions",
    title: "Delivering Staffing Solutions that Match Talent with Your Needs",
    path: "/industry/recruitment&staffing/staffing-agencies",
  },
  {
    img: "/images/icard8.webp",
    alt: "NGO operations fundraising",
    title:
      "Empowering NGO’s by Streamlining Operations from Fundraising to Impact",
    path: "/industry/non-profit/ngos",
  },
];

export const INDUSTRIES = [
  {
    img: banking,
    text: "banking and finance",
    // path: "/industry/banking-finance",
    segments: [
      { text: "BFSI", path: "/industry/banking-finance/bfsi" },
      { text: "Fintech", path: "/industry/banking-finance/fintech" },
      {
        text: "Wealth Management",
        path: "/industry/banking-finance/wealth-management",
      },
    ],
    cards: [
      {
        img: "/images/ibfcard1.webp",
        alt: "Banking legacy innovation",
        title: "Reimagine Banking: Where Legacy Meets Innovation",
        path: "/industry/banking-finance/bfsi",
      },
      {
        img: "/images/ibfcard2.webp",
        alt: "FinTech disruption to scale",
        title: "Salesforce for FinTech: From Disruption to Scale",
        path: "/industry/banking-finance/fintech",
      },
      {
        img: "/images/ibfcard3.webp",
        alt: "Wealth management first principles",
        title:
          "Beyond Intuition. Beyond Guesswork. The First Principles Platform for Wealth Management",
        path: "/industry/banking-finance/wealth-management",
      },
      {
        img: "/images/ibfcard4.webp",
        alt: "FinTech innovation with Utilitarian Labs",
        title:
          "Scale Your FinTech Innovation with the World's #1 CRM & SUMMIT partner Utilitarian Labs",
        path: "/industry/banking-finance/fintech",
      },
    ],
  },
  {
    img: healthcare,
    text: "healthcare & Pharma",
    // path: "/industry/healthcare&pharma",
    segments: [
      {
        text: "Healthcare & Pharma",
        path: "/industry/healthcare&pharma/healthcare-pharma",
      },
    ],
    cards: [
      {
        img: "/images/ihcard1.webp",
        alt: "Healthcare pharma solutions",
        title: "Transforming Healthcare and Pharma with Tailored Solutions",
        path: "/industry/healthcare&pharma/healthcare-pharma",
      },
      {
        img: "/images/ihcard2.webp",
        alt: "Healthcare challenges",
        title: "Addressing Challenges in Healthcare & Pharmaceutical Industry ",
        path: "/industry/healthcare&pharma/healthcare-pharma",
      },
      {
        img: "/images/ihcard3.webp",
        alt: "Healthcare benefits",
        title:
          "Other Benefits of Implementing Salesforce CRM by Utilitarian Labs",
        path: "/industry/healthcare&pharma/healthcare-pharma",
      },
      {
        img: "/images/ihcard4.webp",
        alt: "Healthcare digital trends",
        title: "Current Digital Trends in Healthcare & Pharma",
        path: "/industry/healthcare&pharma/healthcare-pharma",
      },
    ],
  },
  {
    img: education,
    text: "education",
    // path: "/industry/education",
    segments: [
      {
        text: "Higher Education",
        path: "/industry/education/higher-education",
      },
      {
        text: "Pre-schools and K12",
        path: "/industry/education/preschools-k12",
      },

      { text: "EdTech", path: "/industry/education/edtech" },
    ],
    cards: [
      {
        img: "/images/iecard1.webp",
        alt: "EdTech digital solutions",
        title: "Transforming EdTech through Cutting-Edge Digital Solutions",
        path: "/industry/education/edtech",
      },
      {
        img: "/images/iecard2.webp",
        alt: "K-12 education solutions",
        title:
          "Revolutionizing K-12 Education with Smarter and Seamless Operations.",
        path: "/industry/education/preschools-k12",
      },
      {
        img: "/images/iecard3.webp",
        alt: "Higher education solutions",
        title:
          "Transforming Higher Education with Advanced and Effortless Management",
        path: "/industry/education/higher-education",
      },
      {
        img: "/images/iecard4.webp",
        alt: "Higher education digital trends",
        title: "Current Digital Trends in Higher Education System",
        path: "/industry/education/higher-education",
      },
    ],
  },
  {
    img: manufacturing,
    text: "manufacturing",
    // path: "/industry/manufacturing",
    segments: [
      {
        text: "RCG",
        path: "/industry/manufacturing/rcg",
      },
      {
        text: "CORE MANUFACTURING",
        path: "/industry/manufacturing/coremanufacturing",
      },
    ],
    cards: [
      {
        img: "/images/imcard1.webp",
        alt: "Retail consumer goods CRM",
        title:
          "Navigating CRM Transformation: Overcoming Retail Consumer Goods Industry Challenges",
        path: "/industry/manufacturing/rcg",
      },
      {
        img: "/images/imcard2.webp",
        alt: "Retail consumer goods CRM",
        title: "Turning CRM Obstacles into Competitive Advantage",
        path: "/industry/manufacturing/rcg",
      },
      {
        img: "/images/imcard3.webp",
        alt: "Manufacturing end-to-end digital operating model",
        title: "Manufacturing End-to-End Digital Operating Model",
        path: "/industry/manufacturing/coremanufacturing",
      },
      {
        img: "/images/imcard4.webp",
        alt: "EdTech productivity",
        title: "Enhancing Productivity Across All Business Units in EdTech",
        path: "/industry/manufacturing/coremanufacturing",
      },
    ],
  },
  {
    img: automobile,
    text: "automobile",
    // path: "/industry/automobile",
    segments: [
      { text: "Automobile OEM", path: "/industry/automobile/automobile-oem" },
      {
        text: "Automobile Components",
        path: "/industry/automobile/automobile-components",
      },
    ],
    cards: [
      {
        img: "/images/iacard1.webp",
        alt: "Automotive industry solutions",
        title:
          "Revolutionizing the Automotive Industry with Customized Solutions",
        path: "/industry/automobile/automobile-oem",
      },
      {
        img: "/images/iacard2.webp",
        alt: "Automobile OEM solutions",
        title: "Elevate Your Platform with Cutting-Edge Capabilities",
        path: "/industry/automobile/automobile-oem",
      },
      {
        img: "/images/iacard3.webp",
        alt: "Automobile components solutions",
        title:
          "Reshaping the Automobile Components Industry with Customized  Solutions",
        path: "/industry/automobile/automobile-components",
      },
      {
        img: "/images/iacard4.webp",
        alt: "Automobile component manufacturers",
        title:
          "Key Benefits for Automobile Component Manufacturers Units in EdTech",
        path: "/industry/automobile/automobile-components",
      },
    ],
  },

  {
    img: recruitment,
    text: "recruitment & staffing",
    // path: "/industry/recruitment&staffing",
    segments: [
      {
        text: "Staffing Agencies",
        path: "/industry/recruitment&staffing/staffing-agencies",
      },
    ],
    cards: [
      {
        img: "/images/irscard1.webp",
        alt: "Staffing solutions",
        title:
          "Delivering Staffing Solutions that Match Talent with Your Needs",
        path: "/industry/recruitment&staffing/staffing-agencies",
      },
      {
        img: "/images/irscard2.webp",
        alt: "Staffing productivity",
        title: "Enhancing Productivity Across All Business Units in Staffing",
        path: "/industry/recruitment&staffing/staffing-agencies",
      },
      {
        img: "/images/irscard3.webp",
        alt: "Staffing digital trends",
        title: "Current Digital Trends in Staffing",
        path: "/industry/recruitment&staffing/staffing-agencies",
      },
      {
        img: "/images/irscard4.webp",
        alt: "Staffing core functionalities",
        title: "Unlock Core Functionalities to Optimize Operations",
        path: "/industry/recruitment&staffing/staffing-agencies",
      },
    ],
  },
  {
    img: tourism,
    text: "tourism & hospitality",
    // path: "/industry/tourism&hospitality",
    segments: [
      {
        text: "Hotels & Tourism",
        path: "/industry/tourism&hospitality/hotels-tourism",
      },
      {
        text: "Logistics & Transport",
        path: "/industry/tourism&hospitality/logistics-transport",
      },
    ],
    cards: [
      {
        img: "/images/ithcard1.webp",
        alt: "Hospitality CRM solutions",
        title:
          "Revolutionizing Hospitality: Streamlined Experiences with CRM Solutions",
        path: "/industry/tourism&hospitality/hotels-tourism",
      },
      {
        img: "/images/ithcard2.webp",
        alt: "Logistics & transport solutions",
        title:
          "Driving the Future of Logistics: Overcoming Challenges with Innovation",
        path: "/industry/tourism&hospitality/logistics-transport",
      },
      {
        img: "/images/ithcard3.webp",
        alt: "Hospitality & tourism solutions",
        title: "Transforming Hospitality & Tourism with ",
        path: "/industry/tourism&hospitality/hotels-tourism",
      },
      {
        img: "/images/ithcard4.webp",
        alt: "Logistics & transport core functionalities",
        title:
          "Unlock Core Functionalities to Optimize Operations in the Logistics & Transport Industry",
        path: "/industry/tourism&hospitality/logistics-transport",
      },
    ],
  },

  {
    img: NGO,
    text: "Non profit",

    segments: [
      { text: "NGO's", path: "/industry/non-profit/ngos" },
      {
        text: "Educational Non-Profits",
        path: "/industry/non-profit/educational-non-profits",
      },
    ],
    cards: [
      {
        img: "/images/inpcard1.webp",
        alt: "NGO fundraising management software",
        title:
          "Empowering NGO’s by Streamlining Operations from Fundraising to Impact",
        path: "/industry/non-profit/ngos",
      },
      {
        img: "/images/inpcard2.webp",
        alt: "Nonprofit education digital solutions",
        title:
          "Empowering Non-Profit Education with Scalable, Impact-Driven Solutions",
        path: "/industry/non-profit/educational-non-profits",
      },
      {
        img: "/images/inpcard3.webp",
        alt: "NGO digital transformation trends",
        title: "Current Digital Trends in the NGO Non profits",
        path: "/industry/non-profit/ngos",
      },
      {
        img: "/images/inpcard4.webp",
        alt: "Salesforce CRM for NGOs",
        title:
          "Unlocking Core Functionalities in NGO-Non Profits with Salesforce CRM",
        path: "/industry/non-profit/educational-non-profits",
      },
    ],
  },
  {
    img: estate,
    text: "real estate",
    path: "/industry/real-estate",
  },
];
